import { createContext, useState } from "react";

const safeGet = (key) => {
    const val = localStorage.getItem(key);
    return val === "undefined" || val === "null" ? "" : (val || "");
};

export const BarrioContext = createContext();

export const BarrioProvider = ({ children }) => {
    const [barrio, setBarrio] = useState({
        id: localStorage.getItem("barrioId") || null,
        nombre: safeGet("nombreBarrio"),
        cuit: safeGet("barrioCuit"),
        direccion: safeGet("barrioDireccion"),
        razonSocial: safeGet("barrioRazonSocial"),
        numeroCuenta: safeGet("barrioNumeroCuenta"),
        cuentaBancaria: safeGet("barrioCuentaBancaria"),
        tipoCuentaBancaria: safeGet("barrioTipoCuentaBancaria"),
        alias: safeGet("barrioAlias"),
    });

    const seleccionarBarrio = (id, nombre, cuit = "", direccion = "", razonSocial = "", numeroCuenta = "", cuentaBancaria = "", tipoCuentaBancaria = "", alias = "") => {
        localStorage.setItem("barrioId", id);
        localStorage.setItem("nombreBarrio", nombre);
        localStorage.setItem("barrioCuit", cuit);
        localStorage.setItem("barrioDireccion", direccion);
        localStorage.setItem("barrioRazonSocial", razonSocial);
        localStorage.setItem("barrioNumeroCuenta", numeroCuenta);
        localStorage.setItem("barrioCuentaBancaria", cuentaBancaria);
        localStorage.setItem("barrioTipoCuentaBancaria", tipoCuentaBancaria);
        localStorage.setItem("barrioAlias", alias);
        setBarrio({ id, nombre, cuit, direccion, razonSocial, numeroCuenta, cuentaBancaria, tipoCuentaBancaria, alias });
    };

    return (
        <BarrioContext.Provider value={{ barrio, seleccionarBarrio }}>
            {children}
        </BarrioContext.Provider>
    );
};
